import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::approve
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:15
* @route '/pricing/proposals/approve'
*/
export const approve = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(options),
    method: 'post',
})

approve.definition = {
    methods: ["post"],
    url: '/pricing/proposals/approve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::approve
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:15
* @route '/pricing/proposals/approve'
*/
approve.url = (options?: RouteQueryOptions) => {
    return approve.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::approve
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:15
* @route '/pricing/proposals/approve'
*/
approve.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::approve
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:15
* @route '/pricing/proposals/approve'
*/
const approveForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: approve.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::approve
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:15
* @route '/pricing/proposals/approve'
*/
approveForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: approve.url(options),
    method: 'post',
})

approve.form = approveForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::reject
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:28
* @route '/pricing/proposals/reject'
*/
export const reject = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reject.url(options),
    method: 'post',
})

reject.definition = {
    methods: ["post"],
    url: '/pricing/proposals/reject',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::reject
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:28
* @route '/pricing/proposals/reject'
*/
reject.url = (options?: RouteQueryOptions) => {
    return reject.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::reject
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:28
* @route '/pricing/proposals/reject'
*/
reject.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reject.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::reject
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:28
* @route '/pricing/proposals/reject'
*/
const rejectForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reject.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::reject
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:28
* @route '/pricing/proposals/reject'
*/
rejectForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reject.url(options),
    method: 'post',
})

reject.form = rejectForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::rollback
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:37
* @route '/pricing/proposals/rollback'
*/
export const rollback = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: rollback.url(options),
    method: 'post',
})

rollback.definition = {
    methods: ["post"],
    url: '/pricing/proposals/rollback',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::rollback
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:37
* @route '/pricing/proposals/rollback'
*/
rollback.url = (options?: RouteQueryOptions) => {
    return rollback.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::rollback
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:37
* @route '/pricing/proposals/rollback'
*/
rollback.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: rollback.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::rollback
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:37
* @route '/pricing/proposals/rollback'
*/
const rollbackForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: rollback.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingProposalController::rollback
* @see app/Http/Controllers/Admin/Pricing/PricingProposalController.php:37
* @route '/pricing/proposals/rollback'
*/
rollbackForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: rollback.url(options),
    method: 'post',
})

rollback.form = rollbackForm

const proposals = {
    approve: Object.assign(approve, approve),
    reject: Object.assign(reject, reject),
    rollback: Object.assign(rollback, rollback),
}

export default proposals